import React from 'react';
import { useAppTranslation } from '../../i18n/useAppTranslation';
import ShopifyTagModeControl from '../ShopifyTagModeControl';
import { SectionCard } from '../ui';
import type { LightspeedSettingsSectionProps } from './lightspeedSettingsRegistry';

/**
 * Which tags Motzu adds to a Lightspeed item (flag `lightspeed_catalog_tags`), reusing the
 * platform-neutral tag-mode control Shopify has. Link-only integrations write no content, so no tags.
 */
const LightspeedTagModeSection: React.FC<LightspeedSettingsSectionProps> = ({ settings, onChange }) => {
  const { t } = useAppTranslation();
  if (settings.syncMode === 'link_only') return null;
  return (
    <SectionCard title={t('integrations.lightspeedConfig.tags.section')} dense>
      <ShopifyTagModeControl
        flag="lightspeed_catalog_tags"
        tagMode={settings.tagMode}
        onChange={(tagMode) => onChange({ tagMode })}
      />
    </SectionCard>
  );
};

export default LightspeedTagModeSection;
